import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';

import ModalPreviewer from '@components/ModalPreviewer/ModalPreviewer';
import { ShowCase, Preview, Controls } from '@components/ShowCase';
import { FILTERKEYS } from './constants';

const HotspotsList = ({ content }) => {
  const dataGroup = groupBy(content, 'type');
  const dataKeys = Object.keys(dataGroup);

  return (
    <Fragment>
      {dataKeys.map(group => (
        <section key={`${group}-hotspot-group`}>
          <h2 className="h2 page-subtitle">{FILTERKEYS[group]}</h2>
          <ul className="showcase-list">
            {
              dataGroup[group].map(group => (
                group.previews.map((hotspots, i) => (
                  <li key={`hotspot-${group.type}-showcase-${i}`}>
                    <ShowCase codeTemplate={hotspots.codeTemplate}>
                        <Preview className={hotspots.previewClassName}>
                          {(selectedOptions) => (
                            <ModalPreviewer
                              previewText="Preview Hotspot"
                              className={hotspots.modalPreviewClassName}
                              imagePath={selectedOptions.imagePath}
                            >
                              {hotspots.component(selectedOptions)}
                            </ModalPreviewer>
                          )}
                        </Preview>
                      <Controls optionsGroup={hotspots.optionsGroup} />
                    </ShowCase>
                  </li>
                ))
              ))
            }
          </ul>
        </section>
      ))}
    </Fragment>
  );
};

HotspotsList.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object)
};

HotspotsList.displayName = 'HotspotsList';

export default HotspotsList;


// WEBPACK FOOTER //
// ./src/containers/components/Hotspots/HotspotsList.js